import React from 'react';

export default function NoTargetsPlaceholder({ compact = false }) {
  return (
    <div
      className="placeholder-view"
      style={compact ? { minHeight: '180px', padding: '24px' } : undefined}
    >
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        style={{ marginBottom: '18px', opacity: 0.3 }}
      >
        {/* Outer ring */}
        <circle cx="26" cy="26" r="24" stroke="white" strokeWidth="1.5"/>
        {/* Middle ring */}
        <circle cx="26" cy="26" r="15" stroke="white" strokeWidth="1.5"/>
        {/* Inner ring */}
        <circle cx="26" cy="26" r="7" stroke="white" strokeWidth="1.5"/>
        {/* Center dot */}
        <circle cx="26" cy="26" r="2.5" fill="white"/>
        {/* Crosshairs */}
        <line x1="26" y1="1" x2="26" y2="9" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="26" y1="43" x2="26" y2="51" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="1" y1="26" x2="9" y2="26" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="43" y1="26" x2="51" y2="26" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      <p style={{
        color: 'rgba(255,255,255,0.5)',
        fontSize: '0.8rem',
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        margin: '0 0 8px 0',
      }}>
        No Targets Configured
      </p>
      <p style={{
        color: 'rgba(255,255,255,0.3)',
        fontSize: '0.875rem',
        margin: 0,
        maxWidth: '300px',
        lineHeight: '1.6',
      }}>
        Performance dashboards will be available once dealership targets have been set up.
      </p>
    </div>
  );
}
